<script setup>
import { ref } from "vue";
import TipTapReader from "../Editor/TipTapReader.vue";

// Props

const props = defineProps({
    student: {
        type: Object,
        required: true,
    },
    lessonNote: {
        type: String,
        default: "",
    },
    practiceNote: {
        type: String,
        default: "",
    },
});

// Emits

const emit = defineEmits(["reset"]);

// Reactive State

const show = ref(true);

// Methods

function handleReset() {
    show.value = false;
    emit("reset");
}
</script>

<template>
    <SoliResponsiveDialog
        v-model="show"
        persistent
        title="Attendance Notes"
        :mobileScroll="false"
        @reset="handleReset()"
    >
        <template #subtitle
            ><v-btn
                x-small
                rounded
                outlined
                color="accent"
                :href="`/profile/${student.id}/attendance?viewNotes=1`"
                >View All</v-btn
            ></template
        >
        <template #body>
            <v-container>
                <div class="flex flex-col gap-4 px-2">
                    <div class="text-subtitle-2 font-weight-bold soli-grey">
                        {{ `What did you and ${student.first_name} work on?` }}
                    </div>
                    <TipTapReader wrapper :value="lessonNote ?? ''" />
                    <div class="text-subtitle-2 font-weight-bold soli-grey">
                        {{
                            `What should ${student.first_name} work on at home?`
                        }}
                    </div>
                    <TipTapReader wrapper :value="practiceNote ?? ''" />
                </div>
            </v-container>
        </template>
    </SoliResponsiveDialog>
</template>
